import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';
import axios from 'axios';
import { TokenService } from 'src/app/auth/token.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EditorService } from 'src/app/components/editor/editor.service';
declare var $: any;

@Component({
  selector: 'app-stocks',
  templateUrl: './stocks.component.html',
  styleUrls: ['./stocks.component.css']
})
export class StocksComponent implements OnInit {

  constructor(private snackBar: MatSnackBar, private tokenService: TokenService, private route: Router, private activatedRoute: ActivatedRoute, private editorService: EditorService) { }

  username: any = null;
  usertoken: any = null;
  channel: any = { id: null, name: null };
  channelList: any = [];
  videoCanvaList: any = { results: [], page: 1 };
  imageCanvaList: any = { results: [], page: 1 };
  fontCanvaList: any = { results: [], page: 1 };
  fontCanvaListLast: any = [];
  imageCanvaListLast: any = [];
  videoCanvaListLast: any = [];
  fontCanvaSelected: any = [];
  imageCanvaSelected: any = [];
  videoCanvaSelected: any = [];
  videoCanvaCateList: any = [];
  localeList: any = [];
  limit: any = 20;
  getType: any = null; //cate,locale,keyword,title
  selectedCate: any = null;
  selectedCLocale: any = null;
  storageKey: any = null;
  channelId: any = null;
  channelName: any = null;
  canvaType: any = 'video'; //font,image,video
  textVideoInput: any = '';
  textImageInput: any = '';
  textFontInput: any = '';
  configServer: any;
  canva_videos: any = [];
  canva_images: any = [];
  canva_fonts: any = [];


  ngOnInit(): void {
    // this.channelId = this.activatedRoute.snapshot.queryParamMap.get('channel_id');
    this.username = this.tokenService.getUsername();
    this.usertoken = this.tokenService.getToken();
    axios.defaults.headers.common['aux'] = this.usertoken;
    this.editorService.getChannels(this.username).then(results => this.channelList = results);
    this.getCanvaVideoCates();
    this.getLocaleList();
    let state = JSON.parse(localStorage.getItem('currentChannel'));
    this.channelName = state.name;
    this.channelId = state.id;
    this.storageKey = `state_${this.username}_${this.channelId}`;
    this.getCanvaStock();
    // this.selectedCate = "Sea";
    // this.getType = "cate";
    // this.getCanvaVideoByCate(this.selectedCate);
  }

  channelChange(event: any) {
    let selectedOption = event.target.options[event.target.selectedIndex];
    this.channel = { id: selectedOption.value, name: selectedOption.text };
    selectedOption.text = '';
    localStorage.setItem('currentChannel', JSON.stringify(this.channel));
    this.storageKey = `state_${this.username}_${selectedOption.value}`;
    let state = JSON.parse(localStorage.getItem(this.storageKey));
    if (state == null || state == undefined) {
      localStorage.setItem(this.storageKey, JSON.stringify({
        username: this.username,
        channel: this.channel,
        layers: [],
        previews: [],
        outputWidth: 1920,
        outputHeight: 1080,
        dimensions: { workspaceWidth: 960, workspaceHeight: 540 },
        defaultStep: 10,
        thumbnailSeconds: 0,
        autoTemplate: { meta: { auto_upload: false, public_x: true, schedule: null, is_premiere: false }, hub: [], env: [{ name: null, value: null }] },
        projectName: 'Untitled project',
        addedFonts: [],
        lyricData: null,
        lyricSource: 'deezer'
      }));
    }
    window.location.reload();
  }

  typeChange(event: any) {
    let that = this;
    this.canvaType = event.target.value;
    switch (this.canvaType) {
      case 'video':
        $("#text-search").val(this.textVideoInput);
        break;
      case 'image':
        $("#text-search").val(this.textImageInput);
        break;
      case 'font':
        $("#text-search").val(this.textFontInput);
        break;
    }
    $("#type option").each(function () {
      if (that.canvaType == $(this).val()) {
        $('.div-select-' + that.canvaType).fadeIn('slow');
      } else {
        $('.div-select-' + $(this).val()).fadeOut('fast');
      }
    });
  }

  loadMore(page: any) {
    page++;
    switch (this.canvaType) {
      case 'video':
        if (this.selectedCate != "" && this.textVideoInput != "") {
          this.getCanvaVideoByCateKeyword(this.selectedCate, this.textVideoInput, page);
        } else {
          this.getCanvaVideoByCate(this.textVideoInput == '' ? this.selectedCate : this.textVideoInput, page);
        }
        break;
      case 'image':
        this.getCanvaImageByKeyword(this.textImageInput, page);
        break;
      case 'font':
        if (this.textFontInput == '') {
          this.getCanvaFontByLocale(this.selectedCLocale, page);
        } else {
          this.getCanvaFontByTitle(this.textFontInput, page);
        }
        break;
    }
  }

  getLocaleList() {
    const that = this;
    let uri = encodeURIComponent(`https://autoseo.win/getLocale`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        that.localeList = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getCanvaVideoCates() {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/canva/get/cate-list`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        that.videoCanvaCateList = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  canvaSelectChange(event: any) {
    switch (this.canvaType) {
      case 'video':
        this.selectedCate = event.target.value;
        this.getType = 'cate';
        this.videoCanvaList = { results: [], page: 1 };
        this.textVideoInput = $("#text-search").val();
        if (this.selectedCate != "" && this.textVideoInput != "") {
          this.getCanvaVideoByCateKeyword(this.selectedCate, this.textVideoInput);
        } else {
          this.getCanvaVideoByCate(this.selectedCate);
        }
        break;
      case 'font':
        this.selectedCLocale = event.target.value;
        this.fontCanvaList = { results: [], page: 1 };
        this.textFontInput = '';
        $("#text-search").val(this.textFontInput);
        this.getCanvaFontByLocale(this.selectedCLocale);
        break;
    }
  }

  getCanvaVideoByCate(cate: any, page: any = 1) {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/canva/get/${this.getType}/${cate}/${this.limit}/${page}`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        if (response.data.length > 0) {
          that.videoCanvaList.results = [...that.videoCanvaList.results, ...response.data];
          that.videoCanvaList.page = page;
          that.videoCanvaListLast = that.necessaryVideoData(that.videoCanvaList.results);
        } else {
          that.videoCanvaList.page = -1;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getCanvaVideoByCateKeyword(cate: any, keyword: any, page: any = 1) {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/canva/get/keyword-cate/${cate}/${keyword}/${this.limit}/${page}`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        if (response.data.length > 0) {
          that.videoCanvaList.results = [...that.videoCanvaList.results, ...response.data];
          that.videoCanvaList.page = page;
          that.videoCanvaListLast = that.necessaryVideoData(that.videoCanvaList.results);
        } else {
          that.videoCanvaList.page = -1;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getCanvaImageByKeyword(keyword: any, page: any = 1) {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/canva/image/search/keyword/${keyword}/${this.limit}/${page}`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        if (response.data.length > 0) {
          that.imageCanvaList.results = [...that.imageCanvaList.results, ...response.data];
          that.imageCanvaList.page = page;
          that.imageCanvaListLast = that.necessaryImageData(that.imageCanvaList.results);
        } else {
          that.imageCanvaList.page = -1;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getCanvaFontByLocale(locale: any, page: any = 1) {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/canva/font/search/locale/${locale}/${this.limit}/${page}`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        if (response.data.length > 0) {
          that.fontCanvaList.results = [...that.fontCanvaList.results, ...response.data];
          that.fontCanvaList.page = page;
          that.fontCanvaListLast = that.necessaryFontData(that.fontCanvaList.results);
        } else {
          that.fontCanvaList.page = -1;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getCanvaFontByTitle(title: any, page: any = 1) {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/canva/font/search/title/${title}/${this.limit}/${page}`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        if (response.data.length > 0) {
          that.fontCanvaList.results = [...that.fontCanvaList.results, ...response.data];
          that.fontCanvaList.page = page;
          that.fontCanvaListLast = that.necessaryFontData(that.fontCanvaList.results);
        } else {
          that.fontCanvaList.page = -1;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getCanvaStock() {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/stock/manger/get/${this.channelId}`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        that.configServer = response.data;
        var temp = [];
        that.saveStorage({ configServer: that.configServer });
        if (typeof that.configServer.canva_videos != 'undefined') {
          that.canva_videos = JSON.parse(that.configServer.canva_videos);
          temp = [];
          for (const [key, value] of Object.entries(that.canva_videos)) {
            that.getCanvaStockById('video', 'id', value).then(response => {
              if (response != null) {
                that.videoCanvaSelected.push(response);
                that.videoCanvaSelected = that.necessaryVideoData(that.videoCanvaSelected);
              }
            });
          }
        }
        if (typeof that.configServer.canva_images != 'undefined') {
          that.canva_images = JSON.parse(that.configServer.canva_images);
          for (const [key, value] of Object.entries(that.canva_images)) {
            that.getCanvaStockById('image', 'id', value).then(response => {
              if (response != null) {
                that.imageCanvaSelected.push(response);
                that.imageCanvaSelected = that.necessaryImageData(that.imageCanvaSelected);
              }
            });
          }
        }
        if (typeof that.configServer.canva_fonts != 'undefined') {
          that.canva_fonts = JSON.parse(that.configServer.canva_fonts);
          for (const [key, value] of Object.entries(that.canva_fonts)) {
            that.getCanvaStockById('font', 'id', value).then(response => {
              if (response != null) {
                that.fontCanvaSelected.push(response);
                that.fontCanvaSelected = that.necessaryFontData(that.fontCanvaSelected);
              }
            });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getCanvaStockById(canvaType: any, value: any, id: any) {
    return new Promise((resolve, reject) => {
      let result = null;
      let uri = encodeURIComponent(`${environment.magic}/canva/${canvaType}/search/${value}/${id}`);
      axios.get(`/pass/${uri}`)
        .then(function (response) {
          if (response.data.id != 0) {
            if (response.data.sources != undefined) {
              response.data.sources = JSON.parse(response.data.sources);
            }
            if (response.data.images != undefined) {
              response.data.images = JSON.parse(response.data.images);
            }
            result = response.data;
          }
          resolve(result);
        })
        .catch(function (error) {
          console.log(error);
        });
    });
  }

  selectedCanva(item: any) {
    const that = this;
    let state = JSON.parse(localStorage.getItem(this.storageKey));
    if (typeof state.configServer != 'undefined') {
      this.configServer = state.configServer;
    }
    if (typeof this.configServer.canva_videos != 'undefined') {
      this.canva_videos = JSON.parse(this.configServer.canva_videos);
    }
    if (typeof this.configServer.canva_images != 'undefined') {
      this.canva_images = JSON.parse(this.configServer.canva_images);
    }
    if (typeof this.configServer.canva_fonts != 'undefined') {
      this.canva_fonts = JSON.parse(this.configServer.canva_fonts);
    }

    var tag = $("#" + this.canvaType + "_" + item.id);
    switch (this.canvaType) {
      case 'video':
        const indexVideo = this.canva_videos.findIndex(x => x == item.id);
        if (indexVideo == -1) {
          this.canva_videos.push(parseInt(item.id));
          tag.addClass("selected");
          that.makeSelectedCanva(item, 'vid');
        } else {
          this.canva_videos.splice(indexVideo, 1);
          tag.removeClass("selected");
          $("#vid_" + item.id).remove();
        }
        this.configServer.canva_videos = JSON.stringify(this.canva_videos);
        break;
      case 'image':
        const indexImage = this.canva_images.findIndex(x => x == item.id);
        if (indexImage == -1) {
          this.canva_images.push(parseInt(item.id));
          tag.addClass("selected");
          that.makeSelectedCanva(item, 'img');
        } else {
          this.canva_images.splice(indexImage, 1);
          tag.removeClass("selected");
          $("#img_" + item.id).remove();
        }
        this.configServer.canva_images = JSON.stringify(this.canva_images);
        break;
      case 'font':
        const indexFont = this.canva_fonts.findIndex(x => x == item.id);
        if (indexFont == -1) {
          this.canva_fonts.push(parseInt(item.id));
          tag.addClass("selected");
          that.makeSelectedCanva(item, 'fon');
        } else {
          this.canva_fonts.splice(indexFont, 1);
          tag.removeClass("selected");
          $("#fon_" + item.id).remove();
        }
        this.configServer.canva_fonts = JSON.stringify(this.canva_fonts);
        break;
    }

    this.saveStorage({ configServer: this.configServer });
    this.saveServer();

  }

  makeSelectedCanva(item: any, type: any) {
    let that = this;
    $("." + type + "_selected").append('<img id="' + type + '_' + item.id + '" src="' + item?.poster + '">');
    $("#" + type + "_" + item.id).css({ "width": "130px", "margin": "5px", "cursor": "pointer", "background": "#ccc", "border-radius": ".25rem" });
    $("#" + type + "_" + item.id).dblclick(function () {
      that.selectedCanva(item);
    });
  }

  showSelectedCanva(item: any, type: any) {
    var selected = '';
    switch (type) {
      case 'video':
        const indexVideo = this.canva_videos.findIndex(x => x == item.id);
        if (indexVideo != -1) {
          selected = 'selected';
        }
        break;
      case 'image':
        const indexImage = this.canva_images.findIndex(x => x == item.id);
        if (indexImage != -1) {
          selected = 'selected';
        }
        break;
      case 'font':
        const indexFont = this.canva_fonts.findIndex(x => x == item.id);
        if (indexFont != -1) {
          selected = 'selected';
        }
        break;
    }
    return selected;
  }

  saveStorage(obj: any) {
    let state = JSON.parse(localStorage.getItem(this.storageKey));
    for (let [key, value] of Object.entries(obj)) {
      state[key] = value;
    }
    localStorage.setItem(this.storageKey, JSON.stringify(state));
  }

  saveServer() {
    const that = this;
    let formData = new FormData();
    formData.append('user_name', this.username);
    formData.append('channel_id', this.channelId);
    formData.append('canva_videos', JSON.stringify(this.canva_videos));
    formData.append('canva_images', JSON.stringify(this.canva_images));
    formData.append('canva_fonts', JSON.stringify(this.canva_fonts));
    let uri = encodeURIComponent(`${environment.magic}/stock/manger/update`);
    axios.post(`/pass/${uri}`, formData)
      .then(function (response) {
        that.openSnackBar('Saved', 1000);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  mouseOverPlay(item: any) {
    let that = this;
    var image = $("#video_" + item?.id);
    var i = $("#i_" + item?.id);
    if (item.link != "") {
      var video_tag = `<video class="video col-md-12 p-2" id="video_play_${item?.id}" preload="true" muted><source src="${item.link}"></video>`
      image.after(video_tag);
      var video = $("#video_play_" + item?.id);
      video.css({ "position": "absolute", "top": "0px", "left": "0px" });
      i.css({ "left": ".5rem", "width": "95%", "z-index": "0" });
      video.mouseout(function () {
        that.mouseOutPause(item?.id);
      });
      video.click(function () {
        that.selectedCanva(item);
      });
      setTimeout(() => {
        i.css({ "left": "-2000px", "width": "4px", "z-index": "-1" });
        video[0].muted = true;
        // if (video[0].exitFullScreen) video[0].exitFullScreen();
        // video[0].webkitRequestFullScreen();
        video[0].play();
      }, 300);
    } else {
      image.attr("data-toggle", "tooltip");
      image.attr("data-placement", "top");
      image.attr("data-original-title", "Can't play this video");
      $('[data-toggle="tooltip"]').tooltip();
      image.one("click", function () {
        that.selectedCanva(item);
      });
      var listImg = image.attr("data-poster");
      var arrImg = listImg.split(',');
      if (arrImg.length > 1) {
        var index = 0;
        var times = 0;
        var mainLoopId = setInterval(function () {
          const element = arrImg[index];
          image.attr("src", element);
          index++;
          if (index == arrImg.length - 1) {
            times++;
            index = 0;
          }
          if (times == 5) {
            clearInterval(mainLoopId);
          }
        }, 100);
      }
    }
  }

  mouseOutPause(id: any) {
    $("#video_play_" + id)[0].pause();
    $("#video_play_" + id).remove();
    var i = $("#i_" + id);
    i.css({ "width": "4px", "z-index": "-1" });
  }

  search(event: any) {
    switch (this.canvaType) {
      case 'video':
        this.textVideoInput = event.target.value;
        this.selectedCate = $("#select-canva-cate").val();
        this.getType = 'keyword';
        this.videoCanvaList = { results: [], page: 1 };
        if (this.selectedCate != "" && this.textVideoInput != "") {
          this.getCanvaVideoByCateKeyword(this.selectedCate, this.textVideoInput);
        } else {
          this.getCanvaVideoByCate(this.textVideoInput);
        }
        break;
      case 'image':
        this.textImageInput = event.target.value;
        this.imageCanvaList = { results: [], page: 1 };
        this.getCanvaImageByKeyword(this.textImageInput);
        break;
      case 'font':
        this.textFontInput = event.target.value;
        this.fontCanvaList = { results: [], page: 1 };
        this.getCanvaFontByTitle(this.textFontInput);
        break;
    }
  }

  extractFontFromJson(obj) {
    if (!Array.isArray(obj)) {
      obj = JSON.parse(obj);
    }
    return obj[1].direct_link;
  }

  extractFontSourceFromJson(obj) {
    if (!Array.isArray(obj)) {
      obj = JSON.parse(obj);
    }
    var temp = obj[0];
    obj.forEach(item => {
      if (item.style = 'REGULAR') {
        temp = item;
      }
    });
    return temp.files[0].direct_link;
  }

  extractImageFromJson(obj) {
    var objArr;
    if (Array.isArray(obj)) {
      objArr = obj;
    } else {
      objArr = JSON.parse(obj);
    }
    var temp = objArr[0];
    objArr.forEach(item => {
      if (item.height > temp.height && item.width > temp.width) {
        temp = item;
      }
    });
    return temp;
  }

  activeTooltip() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  openSnackBar(message: any, duration: any = 3000) {
    this.snackBar.open(message, '', {
      duration: duration,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: 'bg-primary'
    });
  }

  necessaryFontData(datas: any) {
    var results = [];
    var result = { type: null, id: null, poster: null, link: null, title: null, selected: null, images: null, sources: null };
    datas.forEach(item => {
      result = {
        type: 'font', id: item.id, poster: this.extractFontFromJson(item.images),
        link: this.extractFontSourceFromJson(item.sources), title: item.title, selected: this.showSelectedCanva(item, 'font'), images: item.images, sources: item.sources
      };
      results.push(result);
    });
    return results;
  }

  necessaryImageData(datas: any) {
    var results = [];
    var result = { type: null, id: null, poster: null, link: null, title: null, selected: null, size: null, sources: null };
    datas.forEach(item => {
      var source = this.extractImageFromJson(item.sources);
      result = {
        type: 'font', id: item.id, poster: source.url, link: source.url,
        title: item.title, selected: this.showSelectedCanva(item, 'image'), size: `${source.width}x${source.height}`, sources: item.sources
      };
      results.push(result);
    });
    return results;
  }

  necessaryVideoData(datas: any) {
    var results = [];
    var result = { type: null, id: null, poster: null, listPoster: null, link: null, selected: null, ext: null, md5: null, drive_link: null };
    datas.forEach(item => {
      var poster = (item.poster != null && item.poster != undefined && item.poster.includes(',')) ? item.poster.split(',')[0] : item.poster;
      result = {
        type: 'font', id: item.id, poster: poster, listPoster: item.poster,
        link: item.url_pub, selected: this.showSelectedCanva(item, 'video'), ext: item.ext, md5: item.md5, drive_link: item.drive_link
      };
      results.push(result);
    });
    return results;
  }
}
